module.exports = __webpack_public_path__ + "static/learning-tab-app-cover-cf3cd0784b4aac14a5c807f72e3750c8.png";